import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Telegram from "../../assets/icons/telegram.svg";
import Instagram from "../../assets/icons/insta.svg";
import WhatsApp from "../../assets/icons/whatsUp.svg";

const Footer = ({ showSidbarMarginLeft }) => {
  const location = useLocation();
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [telegram, setTelegram] = useState("");
  const [instagram, setInstagram] = useState("");
  const [whatsApp, setWhatsApp] = useState("");
  // const [workHours, setWorkHours] = useState("");
  // const [aboutUs, setAboutUs] = useState("");
  useEffect(() => {}, [showSidbarMarginLeft]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getConfig`)
      .then((response) => {
        if (!response.ok) {
          return new Error(`error ${response.status} occured...`);
        }
        return response.json();
      })
      .then((res) => {
        setPhone(res.phone);
        setAddress(res.address);
        setEmail(res.email);
        setWhatsApp(res.whatsApp);
        setTelegram(res.telegram);
        setInstagram(res.instagram);
        // setAboutUs(res.aboutUs);
        // setWorkHours(res.workHours);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div
      className={`font-IRANSansWeb w-full text-white font-semibold text-sm caret-transparent bg-[#808083] 
    ${location.pathname !== "/" && showSidbarMarginLeft && "hidden"}

    `}
    >
      <div
        className={`text-right  w-[90%] mx-auto  font-bold pb-2 pt-3
      ${showSidbarMarginLeft ? "text-xs" : "text-base"}
      
      `}
      >
        تماس با ما
      </div>
      <div
        style={{ direction: "rtl" }}
        className=" mx-auto grid grid-cols-2 
        screen500:grid-cols-1
        border-t w-[90%]  border-white 
       
        "
      >
        <div className="grid grid-cols-2 screen700:grid-cols-1">
          <div className="my-4 mx-auto screen700:hidden">
            <iframe
              title="صرافی روبین"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.6853281101094!2d51.4404369763768!3d35.75853832572242!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e041058379f5f%3A0xf97d081e864a7bc5!2sTehran%20Province%2C%20Tehran%2C%20District%203%2C%20Madar%20Square%2C%20Iran!5e0!3m2!1sen!2s!4v1687872757337!5m2!1sen!2s"
              className="rounded-2xl w-[200px] h-[140px] mx-auto  outline-none
            screen1000:w-[170px] screen1000:h-[120px] screen800:w-[140px] screen800:h-[100px] screen800:mt-2
             screen1800:w-[250px] screen1800:h-[170px] screen1800:my-4
            "
            ></iframe>
          </div>

          <div className=" mx-auto my-auto  screen500:w-full screen700:mt-2 screen500:mt-3 ">
            <div className="">
              <span
                className={`font-normal ml-1 
              ${showSidbarMarginLeft ? "text-[10px]" : "text-xs "}
              
              `}
              >
                آدرس :
              </span>
              <span
                className={`${
                  showSidbarMarginLeft ? "text-[10px]" : "screen1200:text-xs"
                }`}
              >
                {address}
              </span>
            </div>

            <div className="my-2">
              <span className="font-normal text-xs ">تلفن : </span>
              <span
                dir="ltr"
                className={`${
                  showSidbarMarginLeft ? "text-[10px]" : "screen1200:text-xs"
                }`}
              >
                {phone}
              </span>
            </div>
            <span className="font-normal text-xs">ایمیل : </span>
            <span
              className={`${
                showSidbarMarginLeft ? "text-[6px]" : "screen1200:text-xs"
              }`}
            >
              {email}
            </span>
          </div>
        </div>

        <div className=" grid grid-cols-2 screen700:grid-cols-1  ">
          <div
            className={`h-fit my-auto  w-[48%]  mx-auto tracking-wider  font-bold 
            screen1550:tracking-normal
            screen1550:w-[50%]
            screen12001300:w-[60%]
            screen1200:w-[75%]
            
            
            screen1200:text-center

          screen700:w-[55%]  
          screen700:text-center  
          
          screen700:mt-2

          screen500:text-right
          screen500:my-5
          screen500:w-[100%] 


          ${
            showSidbarMarginLeft
              ? "text-[9px]"
              : "text-lg  screen1200:text-sm screen700:text-[10px] "
          }

          `}
          >
            ما را در شبکه های اجتماعی دنبال کنید
          </div>

          <div className="my-auto mx-auto w-[60%] screen1200:w-[75%] screen900:w-[85%]  screen500:w-full screen700:mt-3 screen500:mt-0">
            <div
              className={`flex flex-row  h-fit my-auto screen700:mx-auto
          screen500:mx-0
          ${
            showSidbarMarginLeft
              ? "w-full "
              : "w-full screen700:w-[55%] screen500:w-[28%] justify-around "
          }

          `}
            >
              <a
                target="_blank"
                rel="noreferrer"
                // href="https://www.sarafirobin.com"
                href={`https://wa.me/${whatsApp}`}
              >
                <div>
                  <img
                    alt=" واتس اپ صرافی روبین"
                    src={WhatsApp}
                    className="w-7 h-7 screen1000:w-6 screen1000:h-6 screen800:w-5 screen800:h-5 screen1800:w-8 screen1800:h-8"
                  />
                </div>
              </a>
              {/* <a
              target="_blank"
              rel="noreferrer"
              href={`https://t.me/${telegram}`}
            >
              <div className="mx-5 ">
                <img
                  alt="تلگرام صرافی روبین"
                  src={Telegram}
                  className="w-7 h-7  screen1000:w-6 screen1000:h-6 screen800:w-5 screen800:h-5 screen1800:w-8 screen1800:h-8"
                />
              </div>
            </a> */}
              <a
                target="_blank"
                rel="noreferrer"
                href={`https://www.instagram.com/${instagram}`}
              >
                <div>
                  <img
                    alt="اینستاگرام صرافی روبین"
                    src={Instagram}
                    className="w-7 h-7 screen1000:w-6 screen1000:h-6 screen800:w-5 screen800:h-5 screen1800:w-8 screen1800:h-8"
                  />
                </div>
              </a>
            </div>
            <div
              className={`pt-5 text-[#f8f532] text-center screen500:text-right leading-6   screen700:pt-3 screen500:pt-5

                screen700:w-[70%] screen500:mx-0 mx-auto screen500:w-full
                ${
                  showSidbarMarginLeft
                    ? "text-[9px]"
                    : "screen1200:text-sm screen1200:leading-[24px] screen800:text-xs screen800:leading-5 screen700:text-[10px] "
                }
              `}
            >
              صرافی روبین هیچ گونه فعالیتی در پیام رسان تلگرام ندارد .
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ direction: "rtl" }}
        className={`flex flex-row mx-auto justify-between bg-[#606060]  mt-8 px-2 py-1 font-extralight
        
        screen1100:flex-col  screen1100:text-center  screen1800:text-[16px] screen1800:py-2 screen1800:px-3
        screen1100:text-[13px]  screen800:text-[10px]  
     
        ${location.pathname !== "/" && showSidbarMarginLeft && "hidden"}
        `}
      >
        <div className=" ">
          کلیه حقوق مادی و معنوی این سایت متعلق به شرکت تضامنی اسماعیل کوشاسی و
          شرکا ( صرافی روبین) می باشد و کپی از آن پیگرد قانونی دارد .
        </div>

        <div className=" ">
          طراحی شده توسط شرکت &nbsp;
          <a
            className="cursor-pointer "
            href="https://telmis.ir/"
            target="_blank"
            rel="noreferrer"
          >
            <span className="font-bold">تلمیس</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
